<template>
  <div>
    <div class="logobox">
      <div class="hint-text" v-if="showTip">
        <img src="../assets/image/tip.jpg" alt="" width="100%" />
      </div>
      <div class="bgContent">
        <img src="../assets/image/downloadBG.png" class="bg" />
        <img
          v-if="isAndroid"
          src="../assets/image/andorid_btn.png"
          alt=""
          @click="downLoad"
          class="btn"
        />

        <img
          v-if="isIOS"
          src="../assets/image/iphone_btn.png"
          alt=""
          @click="downLoad"
          class="btn"
        />
      </div>
    </div>
  </div>
</template>

<script>
var u = navigator.userAgent;
var isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1; // 微信内
var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端
var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
export default {
  data() {
    return {
      isAndroid,
      isIOS,
      showTip: false,
    };
  },
  methods: {
    downLoad() {
      if (isWeixin) {
        this.showTip = true;
      } else if (isAndroid) {
        window.location.href =
          'https://jbtcmy.oss-cn-shenzhen.aliyuncs.com/smart.apk';
      } else if (isIOS) {
        window.location.href =
          'https://itunes.apple.com/cn/app/id1508993699?mt=8';
      }
    },
  },
};
</script>

<style lang="less" scoped>
.logobox {
  position: relative;
  width: 100vw;
  height: 100vh;
  .hint-text {
    width: 100%;
    text-align: center;
    color: #999;
    font-size: 12px;
  }
  .bgContent {
    position: relative;
    width: 100vw;
    height: 100vh;
    .bg {
      position: absolute;
      width: 100vw;
      height: 100vh;
      object-fit: cover;
      z-index: -1;
    }
    .btn {
      position: absolute;
      bottom: 14%;
      left: 0;
      right: 0;
      margin: 0 auto;
      z-index: 99999;
      width: 250px;
    }
    .btn2 {
      position: absolute;
      bottom: 5px;
      left: 0;
      right: 0;
      margin: 0 auto;
      z-index: 99999;
      width: 250px;
      text-align: center;
      color: rgba(255, 255, 255, 0.658);
      div {
        margin-bottom: 4px;
        font-size: 10px;
      }
      img {
        width: 100px;
      }
    }
  }
}
</style>
